import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepicker, MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: 'passengers-edit',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner,
    MatDividerModule
  ],
  templateUrl: './passengers-edit.component.html',
  styleUrl: './passengers-edit.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class PassengersEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PassengersEditComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading: boolean = false;

  documentMask: string = '';
  columns: any[] = [
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'documento',
      key: 'documento',
      description: 'Documento',
    },
    {
      keyColumn: 'contato',
      key: 'contato',
      description: 'Contato',
    },
    {
      keyColumn: 'companhia',
      key: 'companhia',
      description: 'Companhia',
    },
    {
      keyColumn: 'voo',
      key: 'voo',
      description: 'Vôo',
    },
    {
      keyColumn: 'action',
      key: { add: true },
      description: 'Ações',
    }
  ];
  cellphoneMask: string = '(00) 00000-0000';

  page: number = 1;
  rows: number = 10;
  numberRows: number = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;

  documentTypeList = [
    { id: 'cpf', descricao: 'CPF' },
    { id: 'rg', descricao: 'RG' },
    { id: 'cnh', descricao: 'CNH' }
  ];

  ngOnInit(): void {
    this.createForm();
    this.getPassengersFromApi();
    // this.getPassengerFromOs()
    this.toFillIn()
    console.log("Id do passageiro: ", this.data.idPassageiro)

  }

  createForm(): void {
    this.form = this.formBuilder.group({
      nomePassageiro: ['', [Validators.required]],
      tipoDocumento: [''],
      numeroDoc: [''],
      contato: [''],
      horaChegada: [''],
      horaSaida: [''],
      voo: [''],
      companhia: ['']
    });
  }



  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  closeModal() {
    this.dialog.getDialogById('passengenrs-edit')?.close();
    console.log("Fechar")
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  getListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.passangerService
      .listPagedPassenger(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    console.log(response.data)
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  formatHour(time: any): string {
    if (!time) return '';
    return time.slice(0, 5)
  }

  toFillIn() {

    this.loading = true;

    this.passangerService.getPassengerbyId(this.data.idPassageiro).subscribe({



      next: (res: any) => {
        console.log("Dados do passageiro: ", res)
        this.form.patchValue({
          nomePassageiro: res.data.nome,
          tipoDocumento: res.data.tipoDocumento,
          numeroDoc: res.data.documento,
          contato: res.data.contato,
          voo: res.data.voo,
          companhia: res.data.companhia,
          horaSaida: this.formatHour(res.data.horaPartida),
          horaChegada: this.formatHour(res.data.horaChegada)
        });

      },
      error: (err) => {

        console.error('Erro ao localizar passageiro:', err);
      },
      complete: () => {
        this.loading = false;

      }
    });

  }

  editItem() {
    if (this.form.invalid) return;

    const formatTime = (timeString: string) => {
      if (!timeString) return '';

      // Remove qualquer caractere não numérico
      const numericTime = timeString.replace(/\D/g, '');

      // Garante que temos pelo menos 4 dígitos (hhmm)
      const paddedTime = numericTime.padStart(4, '0');

      // Formata para hh:MM:ss
      return `${paddedTime.substr(0, 2)}:${paddedTime.substr(2, 2)}:00`;
    };

    const model = {
      id: this.data.idPassageiro,
      nome: this.form.get('nomePassageiro')?.value,
      documento: this.form.get('numeroDoc')?.value,
      contato: this.form.get('contato')?.value,
      voo: this.form.get('voo')?.value,
      companhia: this.form.get('companhia')?.value,
      horaPartida: formatTime(this.form.get('horaSaida')?.value),
      horaChegada: formatTime(this.form.get('horaChegada')?.value)

    };

    console.log('Dados sendo enviados:', model);
    this.loading = true;

    this.passangerService.editPassenger(model).subscribe({
      next: (response) => {
        this.getPassengersFromApi();
        this.dialogRef.close({ success: true });
        this.snackbar.success('Passageiro editado com sucesso!');
      },
      error: (err) => {
        this.snackbar.error('Erro ao editar passageiro.')

      },
      complete: () => {
        this.loading = false;

      }
    });
  }

  getPassengersFromApi(): void {
    this.loading = true;


    this.passangerOs.listPagedPassengerOs(this.page, this.rows).subscribe({
      next: (res) => {


        this.passengers = res.data || [];
        this.numberRows = res?.data?.length || 0;
        this.loading = false;


      },
      error: () => {
        this.loading = false;
        console.error('Erro ao buscar passageiros');
      }
    });
  }

  // getPassengerFromOs(){
  //   this.passangerOs.listPassengerOs()
  //   .subscribe({
  //     next: (res) =>{
  //       this.passengerOsList = res.data
  //       console.log("Os passageiros de os: ",this.passengerOsList)
  //     },
  //     error: () =>{
  //       console.log("Nao tem nada nessa porra")
  //     }
  //   })
  // }

  deleteItem(item: any) {
    this.loading = true;
    this.passangerService.deletePassenger({ id: item.id, descricao: '' }).subscribe({
      next: () => {

        this.getPassengersFromApi();
      },
      error: () => {
        this.loading = false;
        console.error('Erro ao excluir passageiro');
      }
    });
  }

  // Você pode implementar add/edit usando os métodos createPassenger/editPassenger da service

  onDocumentTypeChange(type: string) {
    if (type === 'cpf') {
      this.documentMask = '000.000.000-00';
    } else if (type === 'rg') {
      this.documentMask = '00.000.000-0';
    } else if (type === 'cnh') {
      this.documentMask = '00000000000';
    } else {
      this.documentMask = '';
    }
    this.form.get('numeroDoc')?.reset();
  }

  cancel() {
    this.editIndex = null;
    this.response.emit({ action: 'cancel' });
    this.resetForm();
  }

  resetForm() {
    this.form.reset();
  }
}
